import Button from 'common/components/Button/Button';
import PageHeader from 'common/components/PageHeader/PageHeader';
import Table from 'common/components/Table/Table';
import useAuth from 'common/contexts/auth';
import useRouter from 'common/hooks/use-router';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useItem from '../../common/hooks/useItem';
import useList from '../../common/hooks/useList';

const ContractTypesList = () => {
  const { t } = useTranslation();
  const {
    fetchItems,
    items,
    isFetching,
    filters,
    setFilter,
    setPageIndex,
    pageIndex,
    pageCount,
    removeListItem,
  } = useList('contract-types', { defaultFilters: {}, defaultSort: 'name:ASC', cachePrefix: 'contracttypes' });
  const {
    removeItem,
  } = useItem('contract-types');
  const { push } = useRouter();
  const { isAdmin } = useAuth();

  const handleDelete = useCallback(async (id) => {
    removeListItem(id);
    await removeItem(id);
    fetchItems();
  }, [removeListItem, fetchItems, removeItem]);

  const columns = useMemo(() => [
    {
      Header: t('common.name'),
      filterName: 'name_contains',
      className: 'table-start',
      Cell: ({ row: { original: { id, name } } }) => (
        <>
          <div
            className="crud-item-avatar"
            onClick={() => push(`/contract-types/edit/${id}`)}
          >
            <span>{name[0]}</span>
          </div>
          <span className="clickable" onClick={() => push(`/contract-types/edit/${id}`)}>{name}</span>
        </>
      ),
    },
    {
      Header: t('contractType.hasMealVoucher'),
      Cell: ({ row: { original: { has_meal_voucher: hasMealVoucher } } }) => (
        <span>{hasMealVoucher ? t('common.yes') : t('common.no')}</span>
      ),
    },
    {
      Header: t('common.actions'),
      className: 'table-actions',
      // eslint-disable-next-line
      Cell: ({ row: { original: { id } } }) => {
        if (!isAdmin) return null;

        return (
          <>
            <Button
              onClick={() => push(`/contract-types/edit/${id}`)}
              icon="fa-pencil-alt"
              color="primary"
              transparent
            />
            <Button
              // eslint-disable-next-line react/prop-types
              onClick={() => handleDelete(id)}
              icon="fa-trash-alt"
              color="danger"
              confirm
              transparent
              confirmMessage={t('common.delete')}
            />
          </>
        );
      },
    },
  ], [t, push, handleDelete, isAdmin]);

  return (
    <>
      <PageHeader
        title={t('common.contractTypes')}
        link={{ url: '/contract-types/add', icon: 'plus', label: t('common.add') }}
        subLink={{
          url: '/configure',
          icon: 'arrow-left',
          goBack: true,
          label: t('common.back'),
        }}
      />
      <section className="section list-page list-action">
        <Table
          data={items ?? []}
          columns={columns}
          isFetching={isFetching}
          pageCount={pageCount}
          filters={filters}
          setFilter={setFilter}
          setPageIndex={setPageIndex}
          pageIndex={pageIndex}
        />
      </section>
    </>
  );
};

export default ContractTypesList;
